import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68828050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "family-tree-container" }


import FamilyTreeBuilder from "./FamilyTreeBuilder.vue";
import Self from "@/bll/models/Self.mjs";

interface Props {
  self: Self | undefined;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyTreeComponent',
  props: {
    self: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.self)
      ? (_openBlock(), _createBlock(FamilyTreeBuilder, {
          key: 0,
          self: _ctx.self
        }, null, 8, ["self"]))
      : _createCommentVNode("", true)
  ]))
}
}

})